module.exports = __webpack_public_path__ + "img/marketplace.f799d06b.png";